import { createSlice } from "@reduxjs/toolkit";
import {
  createSubcategory,
  updateSubcategory,
  deleteSubcategory,
  reorderSubcategories,
} from "actions/menuSubcategories";

const initialState = {
  loading: false,
  reorderLoading: false,
  error: null,
};

const menuSubcategoriesSlice = createSlice({
  name: "menuSubcategories",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createSubcategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSubcategory.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createSubcategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(updateSubcategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSubcategory.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateSubcategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(deleteSubcategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSubcategory.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteSubcategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(reorderSubcategories.pending, (state) => {
        state.reorderLoading = true;
      })
      .addCase(reorderSubcategories.fulfilled, (state) => {
        state.reorderLoading = false;
      })
      .addCase(reorderSubcategories.rejected, (state, action) => {
        state.reorderLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = menuSubcategoriesSlice.actions;
export default menuSubcategoriesSlice.reducer;
